import { AxiosInstance } from 'axios';
import { TApiResponse } from 'types/common';
import {
  ICheckExistsAccountBody,
  IIsExist,
  InitTeacherBody,
  InitTeacherResponse,
  TeacherRecruitmentDto,
  MigrateTeacherBody,
  MigrateTeacherResponse,
} from 'types/teacherRecruitment';

export const teacherRecruitApi = (axios: AxiosInstance, teacher: string) => ({
  initTeacher(data: InitTeacherBody): TApiResponse<InitTeacherResponse> {
    return axios.post(`${teacher}/signUp`, data);
  },

  migrateTeacher(
    data: MigrateTeacherBody,
  ): TApiResponse<MigrateTeacherResponse> {
    return axios.post(`${teacher}/signUp`, data);
  },

  checkExistsAccount(data: ICheckExistsAccountBody): TApiResponse<IIsExist> {
    return axios.post(`${teacher}/exist-check`, data);
  },
  /** 取得教師資料 */
  get(): TApiResponse<TeacherRecruitmentDto> {
    return axios.get(`${teacher}`);
  },
  /** 更新教師 */
  update(payload: TeacherRecruitmentDto): TApiResponse<TeacherRecruitmentDto> {
    return axios.patch(`${teacher}`, payload);
  },

  /** 發送合約內容 */
  sendContract(payload: {
    contractId: string;
    contractContent: string;
  }): TApiResponse<any> {
    return axios.post(`${teacher}/send-contract`, payload);
  },
  /** 發送終止合約內容 */
  sendTerminatedContract(payload: {
    contractId: string;
    contractContent: string;
  }): TApiResponse<any> {
    return axios.post(`${teacher}/send-terminated-contract`, payload);
  },

  getEmail(oneClubId: string): TApiResponse<{
    email: string;
  }> {
    return axios.get(`${teacher}/email/${oneClubId}`);
  },
});
